import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';

@Injectable()
export class WeightBalanceEffects {
	constructor(private actions$: Actions) {}
}
